// extracted by mini-css-extract-plugin
export default {"root":"Header_root__KkSbk","background":"Header_background__yv-a+"};